import styled from 'styled-components';
import {
  Button as FEFButton,
  ButtonGroup as FEFButtonGroup,
} from '4ff-lib-foundation/lib/components/Button';
import RawMDSIcon from './MDSIcon';

export const Container = styled.div`
  align-items: center;
  height: 100%;
  background-color: ${({ theme }) => theme.lpbDashboard.colors.pageNotFoundBg};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: auto;
`;

export const Button = styled(FEFButton)`
  min-width: auto;
  height: 40px;
  width: 100%;
`;

export const MDSContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 460px;
`;

export const MDSIcon = styled(RawMDSIcon)`
  margin-bottom: 24px;
`;

export const MDSTitle = styled.h1`
  color: #000;
  font-size: 36px;
  font-weight: 500;
  line-height: 40px;
  margin-bottom: 24px;
`;

export const MDSDescription = styled.p`
  color: #000;
  font-size: 18px;
  font-weight: 300;
  line-height: 24px;
  text-align: center;
  margin-bottom: 24px;
`;

export const MDSHint = styled.p`
  color: #4D4D4D;
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  margin-bottom: 24px;
`;

export const MDSButtonGroup = styled(FEFButtonGroup)`
  margin-bottom: 24px;
`;
